'use strict';
const PartnerCredentials = require('../../configurations/partner-credentials');
const chai = require('chai');

const expect = chai.expect;
/* eslint-disable  no-undef */ /* eslint-disable  no-unused-vars */

describe('PartnerCredentials', () => {
  it('On creation validate the credential parameters', (done) => {
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };

    const partnerCredentials = new PartnerCredentials(credentials);
    expect(partnerCredentials.Credentials).to.have.property('domain');
    expect(partnerCredentials.Credentials).to.have.property('clientId');
    expect(partnerCredentials.Credentials).to.have.property('userName');
    expect(partnerCredentials.Credentials).to.have.property('password');
    done();
  });
  it('If credentials are not valid, return an error', (done) => {
    const credentials = {
      doman: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    try {
      const partnerCredentials = new PartnerCredentials(credentials);
    } catch (err) {
      done();
    }
  });
  it('on getCredentials if credentials are not initialized, return an error', (done) => {
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const partnerCredentials = new PartnerCredentials(credentials);
    partnerCredentials.Credentials = '';
    try {
      partnerCredentials.getCredentials();
    } catch (err) {
      done();
    }
  });
});
